import { get, isEmpty, isNil, sortBy } from 'lodash';
import {
  EVENTS,
  ACTIONS,
} from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/constants';
import { resolveJudiciaryProcessType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { stepWithoutDocument } from 'containers/LawyerFeeNote/utils';
import { CLAIM_STATUS_TRACKING } from 'containers/CourtManagerLegalProceedings/constants';
import { TIMELINE_REGULATION_STATUS } from 'containers/data-structure';
import { isDesactivateIntervenant } from 'services/utils';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { RECAP_REJECTION_REGULATION_TYPE } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';

export const renderAction = (type: any) => {
  const actionMap = {
    [ACTIONS.PRE_OPEN]: 'a pré-ouvert',
    [ACTIONS.ADD]: 'a ajouté',
    [ACTIONS.VALIDATE]: 'a validé',
    [ACTIONS.CHANGE]: 'a modifié',
    [ACTIONS.REJECT]: 'a rejeté',
    [ACTIONS.REMOVE]: 'a archivé',
    [ACTIONS.DECISION]: 'a fait une décision sur ',
    [ACTIONS.APPRECIATION]: 'a fait une appréciation sur ',
    [ACTIONS.FIRST_VALIDATION]: 'a fait une premiére validation ',
    [ACTIONS.SECOND_VALIDATION]: 'a fait une deuxiéme validation ',
    [ACTIONS.THIRD_VALIDATION]: 'a fait une troixiéme validation ',
    [ACTIONS.DO_NOT_GENERATE]: 'a choisi de ne pas générer',
    [ACTIONS.GENERATE]: 'a choisi de générer',
  };

  return actionMap[type] || '';
};

export const renderTimelineRegulationDecision = (
  type: any,
  rejectionType: string,
) => {
  const actionMap = {
    [TIMELINE_REGULATION_STATUS.VALIDATED]: 'a validé le ',
    [TIMELINE_REGULATION_STATUS.REJECTED]: `a rejeté ${getRejectionTypeRegulation(
      rejectionType,
    )} le `,
    [TIMELINE_REGULATION_STATUS.PENDING]:
      'Le règlement est en attente de validation, la tâche en cours concerne la bannette',
  };

  return actionMap[type] || '';
};

export const getRejectionTypeRegulation = (rejectiontype: string) => {
  return get(
    RECAP_REJECTION_REGULATION_TYPE.find(
      (el: any) => el.type === rejectiontype,
    ),
    'title',
  )
    ? `- ${get(
        RECAP_REJECTION_REGULATION_TYPE.find(
          (el: any) => el.type === rejectiontype,
        ),
        'title',
      )}`
    : '';
};

export const renderEvent = (type: any): string => {
  const eventMap: Record<string, string> = {
    [EVENTS.CLAIM]: 'le sinistre',
    [EVENTS.FEE_NOTE]: "la note d'honoraire",
    [EVENTS.RISK_CORPO]: 'le risque corporel',
    [EVENTS.ASSIGNEMENT_LAWYER]: "l'assignement du l'avocat ",
    [EVENTS.ASSIGNEMENT_MANAGER]: "l'assignement du gestionnaire ",
    [EVENTS.EXPERT_REPORT]: "le rapport d'expertise",
    [EVENTS.EXPERT_REPORT_APPEAL]: "le rapport d'expertise de l'appel",
    [EVENTS.JUDGEMENT_ADD]: 'le jugement add',
    [EVENTS.APPEAL_ADD]: "l'arret add",
    [EVENTS.JUDGEMENT_ON_MERITS]: 'le jugement au fond',
    [EVENTS.APPEAL_ON_MERITS]: "l'arret au fond",
    [EVENTS.PROVISION_INTERVENANT]: "provision de l'intervenant ",
    [EVENTS.JUDICIARY_PROCESS]: 'la procédure judiciare',
    [EVENTS.VICTIM]: 'la victim ',
    [EVENTS.BENEFICIARY]: "l'ayant droit ",
    [EVENTS.MANUAL_EVALUATION]: 'une évaluation manuelle de ',
    [EVENTS.OPPOSING_PARTY]: 'une partie adverse ',
    [EVENTS.COUNCIL_EXPERT_REPORT]: 'un rapport conseil',
    [EVENTS.COUNCIL_POSTPONE]: "un report d'expertise",
    [EVENTS.NOTICE_DEFICIENCY]: 'un pv de carence',
    [EVENTS.MISSION]: 'une mission',
    [EVENTS.REGULATION]: 'un réglement',
    [EVENTS.STATUS_CLAIM]: 'le status du sinistre',
    [EVENTS.PRIORITY_CLAIM]: 'le flag dossier important motif',
    [EVENTS.INSTRUCTION]: 'une instruction',
    [EVENTS.EXCEPTIONAL_FEE_NOTE]: "une note d'honoraire exceptionnel",
    [EVENTS.JUDGEMENT_ADD_DOCUMENT]: 'le jugement add multiple ',
    [EVENTS.APPEAL_ADD_DOCUMENT]: "l'arret add multiple ",
    [EVENTS.FIRM_REFERENCE]: 'la référence cabinet ',
    [EVENTS.VICTIM_INCOME_CERTIFICATE]: 'une attestion de revenu ',
    [EVENTS.ELIGIBILITY_VICTIM]: "l'égibilité à la transaction ",
    [EVENTS.NON_ELIGIBILITY_VICTIM]: 'non-égibilité à la transaction ',
    [EVENTS.TRANSACTION]: 'une transaction ',
    [EVENTS.IMPORT_JUDICIARE_REPORT]: "une importation d'un rapport judiciare ",
    [EVENTS.IMPORT_COUNCIL_REPORT]: "une importation d'un rapport conseil ",
    [EVENTS.DRIVER]: 'un conducteur ',
    [EVENTS.FRAUDE]: 'a topé le dossier “suspicieux” ',
    [EVENTS.OPPOSITION]: 'un voie de recours',
    [EVENTS.TRANSACTION_CONTACT]: 'la prise de contact à la transaction ',
  };

  return eventMap[type] || '';
};

export const renderParam = (event: any, listings: any, props: any) => {
  switch (get(event, 'event.title')) {
    case EVENTS.VICTIM:
      return (
        get(event, 'victim.firstName') + ' ' + get(event, 'victim.lastName')
      );
    case EVENTS.ASSIGNEMENT_LAWYER:
      const assignedLawyer = !isDesactivateIntervenant(
        get(listings, 'intervenants', []),
        get(event, 'param'),
      )
        ? getValueByCode(get(event, 'param'), get(listings, 'intervenants', []))
        : getValueByCode(
            get(event, 'param'),
            get(listings, 'inactiveIntervenants', []),
          ) + ' (Inactif)';
      return assignedLawyer;
    case EVENTS.PROVISION_INTERVENANT:
      const lawyerInfo = get(listings, 'intervenants', []).find(
        (el: any) => String(el.ItemKey) === get(event, 'text'),
      );
      return (
        get(lawyerInfo, 'ItemDescription', ' ') +
        ' ' +
        'de montant ' +
        get(event, 'param') +
        ' DH'
      );
    case EVENTS.MANUAL_EVALUATION:
      return get(event, 'param') + ' DH';
    case EVENTS.BENEFICIARY:
      if (isEmpty(get(event, 'beneficiary', {}))) {
        return get(event, 'param', '');
      }
      return (
        get(event, 'beneficiary.firstName', '') +
        ' ' +
        get(event, 'beneficiary.lastName', '')
      );
    case EVENTS.EXPERT_REPORT:
    case EVENTS.JUDGEMENT_ADD:
    case EVENTS.JUDGEMENT_ADD_DOCUMENT:
    case EVENTS.APPEAL_ADD_DOCUMENT:
    case EVENTS.JUDGEMENT_ON_MERITS:
    case EVENTS.APPEAL_ON_MERITS:
    case EVENTS.EXPERT_REPORT_APPEAL:
    case EVENTS.OPPOSITION:
    case EVENTS.APPEAL_ADD:
      return (
        ' de la procédure ' +
        resolveJudiciaryProcessType(
          get(event, 'judiciaryProcess.procedureNatureId'),
        ) +
        ' ' +
        get(event, 'judiciaryProcess.courtNumber', '')
      );
    case EVENTS.JUDICIARY_PROCESS:
      return (
        ' ' +
        resolveJudiciaryProcessType(
          get(event, 'judiciaryProcess.procedureNatureId'),
        ) +
        ' ' +
        get(event, 'judiciaryProcess.courtNumber', '')
      );
    case EVENTS.FEE_NOTE:
    case EVENTS.EXCEPTIONAL_FEE_NOTE:
      return !isNil(get(event, 'feeNote.step', null))
        ? " de l'étape " +
            stepWithoutDocument(get(event, 'feeNote.step', ''), props)
        : '';
    case EVENTS.OPPOSING_PARTY:
      return (
        "sous l'immatricule " + get(event, 'vehicle.registrationNumber', '')
      );
    case EVENTS.MISSION:
      return ' ' + get(event, 'mission.reference', '');
    case EVENTS.NOTICE_DEFICIENCY:
    case EVENTS.COUNCIL_POSTPONE:
      return (
        ' de la mission ' + get(event, 'missionPostpone.mission.reference', '')
      );
    case EVENTS.COUNCIL_EXPERT_REPORT:
      return (
        ' de la mission ' +
        (!isNil(get(event, 'missionExpertiseVictim.mission.reference', null))
          ? get(event, 'missionExpertiseVictim.mission.reference')
          : get(event, 'missionExpertiseVehicle.mission.reference'))
      );
    case EVENTS.STATUS_CLAIM:
      return ' a ' + get(CLAIM_STATUS_TRACKING, get(event, 'param', ''));
    case EVENTS.PRIORITY_CLAIM:
      const objectReason = get(listings, 'priorityClaimReason', []).find(
        (el: any) => String(el.id) === get(event, 'param'),
      );
      return ' : ' + get(objectReason, 'title');
    case EVENTS.VICTIM_INCOME_CERTIFICATE:
    case EVENTS.ELIGIBILITY_VICTIM:
    case EVENTS.NON_ELIGIBILITY_VICTIM:
      return (
        'de la victime ' +
        get(event, 'victim.firstName') +
        ' ' +
        get(event, 'victim.lastName')
      );
    case EVENTS.TRANSACTION:
      return (
        'dont la référence ' +
        get(event, 'transaction.victim.firstName') +
        ' ' +
        get(event, 'transaction.victim.lastName') +
        ' ' +
        get(event, 'transaction.victim.cin')
      );
    case EVENTS.TRANSACTION_CONTACT:
      return (
        'dont la référence ' +
        get(event, 'transactionContact.transaction.victim.firstName') +
        ' ' +
        get(event, 'transactionContact.transaction.victim.lastName') +
        ' ' +
        get(event, 'transactionContact.transaction.victim.cin')
      );
    case EVENTS.DRIVER:
      return (
        'dont le nom ' +
        get(event, 'driver.firstName') +
        ' ' +
        get(event, 'driver.lastName')
      );
    case EVENTS.REGULATION:
      return get(event, 'regulation.settlementPhase', {}) === 'TRANSACTION' &&
        !isEmpty(get(event, 'regulation.regulationVictims.[0].victim', {}))
        ? ` transactionel pour le bénéficiare: ${get(
            event,
            'regulation.regulationVictims.[0].victim.firstName',
            {},
          )}  ${get(
            event,
            'regulation.regulationVictims.[0].victim.lastName',
            {},
          )}`
        : ' judiciare';
    default:
      return '';
  }
};
export const parseDate = (date: any, time: any) => {
  const [day, month, year] = date.split('/').map(Number);
  const [hour, minutes, secondes] = time.split(':').map(Number);
  return new Date(year, month - 1, day, hour, minutes, secondes);
};

export const formatSagisMessage = (Sagishistory: any, corpoHistory: any) => {
  const getDateOfMessagesSagis = Sagishistory?.map((item: any) => {
    return {
      item: item,
      createdAt: new Date(
        parseDate(item.split(' ')?.at(-2), item.split(' ')?.at(-1)),
      ),
      isCorpo: false,
    };
  });
  const getDateOfMessagesCorpo = corpoHistory?.map((item: any) => ({
    ...item,
    isCorpo: true,
    createdAt: new Date(get(item, 'createdAt')),
  }));
  return sortBy(
    [
      ...getDateOfMessagesSagis,
      ...(getDateOfMessagesCorpo ? getDateOfMessagesCorpo : []),
    ],
    'createdAt',
  );
};
